import * as stylex from '@stylexjs/stylex'
import { Loading } from '../Icons'
import { type SvgIconProps } from '../SvgIcon/SvgIcon'

const rotate = stylex.keyframes({
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' },
})

const baseStyles = stylex.create({
  root: {
    animationDuration: '1s',
    animationIterationCount: 'infinite',
    animationName: rotate,
    animationTimingFunction: 'linear',
  },
})

/** CircularProgress 的 props，繼承 SvgIcon 的 props（不含 children）。 */
export type CircularProgressProps = Omit<SvgIconProps, 'children'>

/**
 * CircularProgress 是圓形載入指示器，帶有持續旋轉動畫。
 */
export const CircularProgress = (props: CircularProgressProps) => {
  const { rootStyle, ...rest } = props
  return (
    <Loading rootStyle={[baseStyles.root, rootStyle]} {...rest} />
  )
}
